import React from 'react';

import { Box, Text } from '@opendoor/bricks/core';

type ModalHeaderProps = {
  eyebrowText?: React.ReactNode;
  headerText: React.ReactNode;
};

const ModalHeader: React.FC<ModalHeaderProps> = ({ eyebrowText, headerText }) => (
  <Box>
    <Text fontSize={['14px', null, '16px']} fontWeight="medium">
      {eyebrowText}
    </Text>
    <Text
      as="h1"
      // size="200"
      fontWeight="medium"
      fontSize={['28px', null, '40px']}
      lineHeight={['110', null, '100']}
      // @ts-expect-error design system doesn't have these values
      letterSpacing={['-0.784px', null, '-1.2px']}
      marginTop={['6px', null, '12px']}
      marginBlockEnd={[0, 0, 0]}
    >
      {headerText}
    </Text>
  </Box>
);

export default ModalHeader;
